// All GSAP scroll/entrance animations for the theme live in this file.
// GSAP + ScrollTrigger are enqueued globally as window globals —
// u10-main depends on them, so they're guaranteed to exist before this runs.
// Add new animations as functions and call them from initAnimations().

// Dot pattern reveal (template-parts/patterns/dots.php) — dots pop in,
// staggered outward from the centre, when the pattern scrolls into view.
const animateDots = () => {
  for (const svg of document.querySelectorAll('svg.dots')) {
    const dots = [...svg.querySelectorAll('path')]
    if (!dots.length) {
      continue
    }

    // Order the dots by distance from the pattern's centre so the stagger
    // radiates outward, regardless of DOM order.
    const vb = svg.viewBox.baseVal
    const cx = vb.x + vb.width / 2
    const cy = vb.y + vb.height / 2
    const sorted = dots
      .map((el) => {
        const b = el.getBBox()
        return {
          el,
          dist: Math.hypot(b.x + b.width / 2 - cx, b.y + b.height / 2 - cy),
        }
      })
      .sort((a, b) => a.dist - b.dist)
      .map((item) => item.el)

    window.gsap.from(sorted, {
      scale: 0,
      transformOrigin: '50% 50%',
      duration: 0.6,
      ease: 'back.out(2)',
      stagger: 0.06,
      scrollTrigger: {
        trigger: svg,
        start: 'top 75%',
        once: true,
      },
    })
  }
}

// Elements with .fade-in start hidden (see _base.css) and slide/fade in
// as they enter the viewport. The CSS transition does the animating —
// ScrollTrigger only flips the class on.
const batchFadeIn = () => {
  window.ScrollTrigger.batch('.fade-in', {
    start: 'top 90%',
    toggleClass: 'item-reveal-up',
    once: true,
  })
}

// If GSAP never loaded, .fade-in elements would stay invisible — reveal
// them all so a CDN/asset failure degrades to a static page.
const revealAllFadeIns = () => {
  for (const el of document.querySelectorAll('.fade-in')) {
    el.classList.add('item-reveal-up')
  }
}

export const initAnimations = () => {
  if (!(window.gsap && window.ScrollTrigger)) {
    revealAllFadeIns()
    return
  }
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return
  }

  animateDots()
  batchFadeIn()
}
